import styles from './statusPagamentoCard.module.scss';

interface IstatusPagamentoCardProps {
  readonly status: string;
  readonly description: string;
  readonly icon: string;
}

function statusPagamentoCard({ status, description, icon }: IstatusPagamentoCardProps) {
  const getStatusColor = (status: string): string => {
    if (status === 'success') return 'green';
    if (status === 'running') return 'blue';
    if (status === 'standBy') return 'gray';
    if (status === 'error') return 'red';
    return 'black';
  };

  const getTitleByStatus = (status: string): string => {
    switch (status) {
      case 'success':
        return 'concluído';
      case 'running':
        return 'em andamento';
      case 'standBy':
        return 'aguardando';
      case 'error':
        return 'rejeitado';
      default:
        return '';
    }
  };

  const color = getStatusColor(status);

  return (
    <div className={styles.statusPagamentoCardContainer}>
      {icon === 'guiaEmitida' && (
        <>
          <div className={styles.iconContainer + ' ' + styles[status]}>
            <i className={`fas fa-check-circle fa-lg`} />
          </div>
          <div className={styles.svgContainer}>
            <svg
              width='100'
              height='110'
              viewBox='0 0 100 123'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              data-testid='guia-emitida-svg'
            >
              <title>Passo de emissão de guia {getTitleByStatus(status)}</title>
              <path d='M84.3097 66.1094H35.875V69.1282H84.3097V66.1094Z' fill={color} />
              <path d='M84.3097 56.5742H35.875V59.593H84.3097V56.5742Z' fill={color} />
              <path d='M84.3097 75.6797H35.875V78.6985H84.3097V75.6797Z' fill={color} />
              <path d='M84.3097 85.2188H35.875V88.2375H84.3097V85.2188Z' fill={color} />
              <path d='M84.3097 94.7891H35.875V97.8078H84.3097V94.7891Z' fill={color} />
              <path
                d='M7.56498 96.3586V97.868L12.4618 107.196V111.362H15.6008V107.196L20.4976 97.8982V17.7194H18.3317V11.4102H9.76228V17.7194H7.59637V23.4551H5.6188C2.5112 23.4551 0 25.8701 0 28.8587V59.288H3.139V28.8587C3.139 27.5304 4.23764 26.4739 5.6188 26.4739H7.59637V96.3888L7.56498 96.3586ZM17.3586 97.1737L14.0313 103.513L10.704 97.1737V96.3586H17.3586V97.1737ZM12.8699 14.4289H15.1614V17.7194H12.8699V14.4289ZM10.704 20.7382H17.3586V23.4551H10.704V20.7382ZM10.704 26.4739H17.3586V93.37H10.704V26.4437V26.4739Z'
                fill={color}
              />
              <path
                d='M79.0078 0H12.4297V7.15451H15.5687V3.01878H76.7791V21.7654H96.6489V119.121H15.5687V115.287H12.4297V122.14H99.8193V18.9881L79.0078 0ZM79.9495 5.01117L95.0167 18.7466H79.9495V5.01117Z'
                fill={color}
              />
              <path
                d='M84.3097 36.043H35.875V49.5369H84.3097V36.043ZM81.1707 46.5181H39.014V39.0617H81.1707V46.5181Z'
                fill={color}
              />
            </svg>
          </div>
        </>
      )}

      {icon === 'aguardandoConfirmacao' && (
        <>
          <div className={styles.iconContainer}>
            <div className={styles.ampulhetaContainer + ' ' + styles[status]}>
              <i className={`fas fa-hourglass-start fa-sm`} />
            </div>
          </div>
          <div className={styles.svgContainer}>
            <svg
              width='115'
              height='94'
              viewBox='0 0 115 94'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              data-testid='aguardando-confirmacao-svg'
            >
              <title>Passo de confirmação de pagamento {getTitleByStatus(status)}</title>
              <path
                d='M108.409 0H5.70572C2.55509 0 0 3.00034 0 6.7V87.1C0 90.7997 2.55509 93.8 5.70572 93.8H108.409C111.559 93.8 114.114 90.7997 114.114 87.1V6.7C114.114 3.00034 111.559 0 108.409 0ZM31.3814 61.9499V65.325C31.3814 66.2504 30.7431 67 29.955 67H27.1022C26.3141 67 25.6757 66.2504 25.6757 65.325V61.9143C23.6627 61.7928 21.7049 60.9679 20.0823 59.5379C19.387 58.9244 19.3513 57.7017 19.9807 56.9961L22.0758 54.649C22.5697 54.0962 23.3043 54.0711 23.882 54.4961C24.572 55.0028 25.3548 55.275 26.1678 55.275H31.18C32.3389 55.275 33.2839 54.0355 33.2839 52.5133C33.2839 51.2676 32.6403 50.1704 31.7202 49.848L23.6966 47.0214C20.3819 45.8531 18.0657 42.1179 18.0657 37.9367C18.0657 32.8028 21.4624 28.632 25.6739 28.5001V25.125C25.6739 24.1996 26.3123 23.45 27.1004 23.45H29.9532C30.7413 23.45 31.3797 24.1996 31.3797 25.125V28.5357C33.3927 28.6572 35.3505 29.48 36.973 30.9121C37.6684 31.5256 37.7041 32.7483 37.0747 33.4539L34.9796 35.801C34.4857 36.3538 33.7511 36.3789 33.1734 35.9539C32.4834 35.4451 31.7006 35.175 30.8875 35.175H25.8754C24.7164 35.175 23.7714 36.4145 23.7714 37.9367C23.7714 39.1824 24.4151 40.2796 25.3352 40.602L33.3588 43.4286C36.6735 44.5969 38.9897 48.3321 38.9897 52.5133C38.9897 57.6493 35.593 61.818 31.3814 61.9499ZM74.1743 58.625C74.1743 59.5504 73.536 60.3 72.7479 60.3H52.7779C51.9898 60.3 51.3514 59.5504 51.3514 58.625V55.275C51.3514 54.3496 51.9898 53.6 52.7779 53.6H72.7479C73.536 53.6 74.1743 54.3496 74.1743 55.275V58.625ZM102.703 58.625C102.703 59.5504 102.065 60.3 101.276 60.3H87.0122C86.2241 60.3 85.5857 59.5504 85.5857 58.625V55.275C85.5857 54.3496 86.2241 53.6 87.0122 53.6H101.276C102.065 53.6 102.703 54.3496 102.703 55.275V58.625ZM102.703 38.525C102.703 39.4504 102.065 40.2 101.276 40.2H52.7779C51.9898 40.2 51.3514 39.4504 51.3514 38.525V35.175C51.3514 34.2496 51.9898 33.5 52.7779 33.5H101.276C102.065 33.5 102.703 34.2496 102.703 35.175V38.525Z'
                fill={color}
              />
            </svg>
          </div>
        </>
      )}

      {icon === 'pagamentoConcluido' && (
        <>
          <div className={styles.iconContainer + ' ' + styles[status]}></div>

          <div className={styles.svgContainer}>
            <svg
              width='120'
              height='120'
              viewBox='0 0 139 120'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              data-testid='pagamento-concluido-svg'
            >
              <title>Passo de conclusão do pagamento {getTitleByStatus(status)}</title>
              <path
                d='M136.835 16.2092L130.344 9.92564C129.412 9.02339 128.148 8.50781 126.816 8.50781C125.485 8.50781 124.253 8.99116 123.321 9.89342L66.4052 60.1297L50.6284 44.8558C48.6979 42.9869 45.5359 42.9869 43.6054 44.8558L37.0817 51.1716C36.1497 52.0739 35.6172 53.2984 35.6172 54.5873C35.6172 55.8762 36.1497 57.0685 37.0817 58.003L62.8105 82.9117C63.7758 83.8462 65.0738 84.3295 66.3719 84.3295C67.67 84.3295 68.9015 83.8784 69.8335 82.9439L136.835 23.0406C138.765 21.1394 138.765 18.0782 136.835 16.2092ZM134.538 20.7205L67.5369 80.6238C66.8712 81.2683 65.8061 81.2683 65.1737 80.6238L39.4449 55.7151C39.1453 55.4251 38.9789 55.0062 38.9789 54.5873C38.9789 54.1684 39.1453 53.7817 39.4449 53.4595L45.9686 47.1437C46.3015 46.8214 46.7009 46.6926 47.1336 46.6926C47.5663 46.6926 47.9657 46.8537 48.2985 47.1437L66.3054 64.5766L125.585 12.2457L125.651 12.1813C125.951 11.8913 126.384 11.6979 126.816 11.6979C127.249 11.6979 127.682 11.859 128.015 12.1813L134.505 18.4648C135.171 19.1093 135.171 20.1082 134.538 20.7205Z'
                fill={color}
              />
              <path
                d='M61.9777 18.5622C73.0947 18.5622 83.6458 22.6868 91.6674 30.1626C92.3331 30.7749 93.3649 30.7749 94.0306 30.1304C94.663 29.4859 94.663 28.4548 93.9973 27.8425C85.3433 19.7867 73.9934 15.3398 62.011 15.3398C36.5818 15.3398 15.8789 35.3828 15.8789 60.0015C15.8789 84.6202 36.5818 104.663 62.011 104.663C87.4403 104.663 107.411 85.6191 108.11 61.2904C108.11 60.3882 107.411 59.647 106.479 59.647C105.58 59.647 104.781 60.3237 104.781 61.226C104.116 83.7824 85.3433 101.441 62.011 101.441C38.6787 101.441 19.2073 82.8479 19.2073 60.0015C19.2073 37.1551 38.4124 18.5622 62.011 18.5622H61.9777Z'
                fill={color}
              />
              <path
                d='M120.489 45.725C119.591 45.9184 119.025 46.7884 119.225 47.6584C120.156 51.6864 120.622 55.8432 120.622 60C120.622 91.3212 94.3278 116.778 61.9755 116.778C29.6231 116.778 3.32843 91.2889 3.32843 60C3.32843 28.7111 29.6231 3.22234 61.9755 3.22234C77.3528 3.22234 91.8648 8.92589 102.882 19.3018C103.548 19.9141 104.613 19.9141 105.245 19.3018C105.878 18.6574 105.878 17.6584 105.245 17.014C93.5623 6.02578 78.2182 0 61.9755 0C27.7924 0 0 26.9066 0 60C0 93.0935 27.7924 120 61.9755 120C96.1585 120 123.951 93.0935 123.951 60C123.951 55.5854 123.452 51.203 122.486 46.9495C122.287 46.0795 121.421 45.5317 120.489 45.725Z'
                fill={color}
              />
            </svg>
          </div>
        </>
      )}

      {icon === 'pagamentoRejeitadoCanceladoVencido' && (
        <>
          <div className={styles.iconContainer + ' ' + styles[status]}></div>

          <div className={styles.svgContainer}>
            <svg
              width='120'
              height='120'
              viewBox='0 0 138 132'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              data-testid='pagamento-rejeitado-cancelado-vencido-svg'
            >
              <title>Pagamento {getTitleByStatus(status)}</title>
              <path
                d='M69 126.844C60.4289 126.844 52.0734 125.245 44.257 122.048C36.6562 119.006 29.8641 114.623 24.0422 109.003C18.2203 103.434 13.6383 96.8859 10.4039 89.6672C7.06172 82.1391 5.39062 74.1984 5.39062 66C5.39062 57.8016 7.06172 49.8094 10.4039 42.3328C13.5844 35.0625 18.1664 28.5656 24.0422 22.9969C29.8641 17.3766 36.6562 12.9937 44.257 9.95156C52.1273 6.75469 60.4289 5.15625 69 5.15625C77.5711 5.15625 85.9266 6.75469 93.743 9.95156C101.29 12.9937 108.136 17.3766 113.958 22.9969C119.78 28.5656 124.362 35.1141 127.596 42.3328C130.938 49.8609 132.609 57.8016 132.609 66C132.609 74.1984 130.938 82.1906 127.596 89.6672C124.416 96.9375 119.834 103.434 113.958 109.003C108.136 114.572 101.29 118.955 93.743 122.048C85.9266 125.245 77.5711 126.844 69 126.844ZM69 8.55938C60.9141 8.55938 53.0437 10.0547 45.6586 13.0453C38.4891 15.9844 32.0742 20.1094 26.5758 25.3687C21.0234 30.6797 16.7109 36.8156 13.6922 43.6219C10.5656 50.6859 9.00234 58.2141 9.00234 65.9484C9.00234 73.6828 10.5656 81.2109 13.6922 88.275C16.7109 95.1328 21.0234 101.269 26.5758 106.528C32.0742 111.891 38.4891 116.016 45.6586 118.903C53.0437 121.894 60.9141 123.389 69 123.389C77.0859 123.389 84.9563 121.894 92.3414 118.903C99.5109 116.016 105.926 111.891 111.424 106.58C116.923 101.32 121.289 95.1844 124.308 88.3266C127.434 81.2625 128.998 73.7344 128.998 66C128.998 58.2656 127.434 50.7375 124.308 43.6734C121.289 36.8156 116.977 30.6797 111.424 25.3687C105.926 20.1094 99.5109 15.9844 92.3414 13.0969C84.9563 10.1062 77.0859 8.55938 69 8.55938Z'
                fill={color}
              />
              <path
                d='M48.3071 41.1269C45.3312 41.7658 43.2371 44.1673 43.0167 47.1636C42.9285 48.2211 43.1931 49.4108 43.7221 50.5123L44.1189 51.3716L51.9001 59.1707L59.7034 66.9919L51.9221 74.791L44.1189 82.5901L43.7 83.4494C43.0167 84.8594 42.8404 86.2033 43.149 87.7014C43.5457 89.6622 44.9124 91.4468 46.6538 92.284C48.6157 93.2313 50.5555 93.2313 52.5394 92.284L53.399 91.8874L61.2023 84.1103L69.0056 76.3112L76.8089 84.0883L84.6122 91.8874L85.4718 92.306C87.4337 93.2313 89.3955 93.2313 91.3574 92.306C92.5697 91.7332 93.716 90.5876 94.2891 89.3758C95.237 87.415 95.237 85.4542 94.2891 83.4934L93.8703 82.6342L86.067 74.8351L78.3078 66.9919L86.1111 59.1927L93.8923 51.3936L94.2891 50.5344C95.237 48.5515 95.237 46.6128 94.2891 44.652C93.716 43.4402 92.5697 42.2946 91.3574 41.7218C89.3955 40.7744 87.4116 40.7744 85.4718 41.7218L84.6122 42.1404L76.8089 49.9395L69.0056 57.6946L61.2023 49.8955L53.399 42.1183L52.5394 41.7218C51.1065 41.0388 49.6737 40.8405 48.3071 41.1269Z'
                stroke={color}
                stroke-width='3'
              />
              <path
                d='M69.1777 25.2223C80.5549 25.2223 91.3529 29.3469 99.5622 36.8228C100.243 37.435 101.299 37.435 101.981 36.7905C102.628 36.1461 102.628 35.1149 101.947 34.5027C93.0902 26.4468 81.4746 22 69.2118 22C43.1874 22 22 42.043 22 66.6617C22 91.2803 43.1874 111.323 69.2118 111.323C95.2362 111.323 115.674 92.2793 116.389 67.9506C116.389 67.0483 115.674 66.3072 114.72 66.3072C113.801 66.3072 112.983 66.9839 112.983 67.8861C112.302 90.4425 93.0902 108.101 69.2118 108.101C45.3334 108.101 25.4063 89.5081 25.4063 66.6617C25.4063 43.8153 45.0609 25.2223 69.2118 25.2223H69.1777Z'
                fill={color}
              />
            </svg>
          </div>
        </>
      )}

      <div className={styles.descriptionContainer}>
        <span className={styles.description + ' ' + styles[status]}>{description}</span>
      </div>
    </div>
  );
}

export default statusPagamentoCard;
